import { createTheme } from "@mui/material";

const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "IRANSansXFaNum, Arial",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
            font-family: 'IRANSansXFaNum';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
          }
        `,
    },
  },
});

export default theme;
